<template>

    <v-container v-if="!loggedUser">
      <v-row>
        <v-col md="4" class="pa-2" >
          <LoginForm redirectUrl="account"></LoginForm>
        </v-col>
        <v-col md="6" class="pa-2">
          <CreateUser redirectUrl="account"></CreateUser>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>

  import { mapGetters } from 'vuex';
  import LoginForm from '../../../shared/components/LoginForm'

  export default {
    name: 'login',
    components: { LoginForm },
    methods: {
    },
    computed: {
      ...mapGetters({ appName: 'main/appName', loggedUser: 'main/loggedUser' })
    }
  }
</script>

<style scoped>


</style>
